@if (!routingService.getFormMode() && mapService.$onClickPosition()) {
  <div class="map-action" [style.left.px]="layoutService.leftMapOffset()">
    @if (mapService.$onClickDirection()) {
      <div class="direction-info-card">
        <button matIconButton (click)="closeDirection()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        @if (mapService.direction.distance !== undefined) {
          <div class="direction-info-card-content" style="font-family: var(--mat-sys-plain-font-family); font-weight: var(--mat-sys-medium-font-weight)">
            <div>
              <mat-icon color="accent">outlined_flag</mat-icon>
              <p>
                {{ mapService.direction.distance / 1000 | imperial: 'distance' }}
              </p>
            </div>
            <div>
              <mat-icon color="accent">access_time</mat-icon>
              <p>{{ mapService.direction.duration * 1000 | duration }}</p>
            </div>
          </div>
        }
        @if (
          !mapService.direction.distance !== undefined &&
          mapService.direction.start !== undefined &&
          mapService.direction.stop === undefined
        ) {
          <p style="font-family: var(--mat-sys-plain-font-family); font-weight: var(--mat-sys-medium-font-weight)">{{ 'MAP.CLICKONMAPARRIVAL' | translate }}</p>
        }
        <button matIconButton (click)="closeMapAction()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    } @else {
      <div class="click-address">
        <mat-icon color="accent">place</mat-icon>

        <div>
          @if (mapService.clickPos.addr !== undefined && mapService.clickPos.addr !== ' ') {
            <p>{{ mapService.clickPos.addr }}</p>
          } @else {
            <p>{{ 'MAP.NOADDRESS' | translate }}</p>
          }
          @if (mapService.clickPos.lon !== undefined && mapService.clickPos.lat !== undefined) {
            <p class="info-position">
              {{ mapService.clickPos.lat.toFixed(4) }},
              {{ mapService.clickPos.lon.toFixed(4) }}
            </p>
          }
        </div>
      </div>

      <mat-divider vertical style="height: auto"></mat-divider>

      <div class="flex-map-option">
        <ng-container *hasPermission="['WRITE', 'poi']">
          <button matMiniFab color="accent" (click)="addPoi()" [matTooltip]="'COMMON.SAVE' | translate">
            <mat-icon>add_location_alt</mat-icon>
          </button>
        </ng-container>

        <button matMiniFab color="accent" (click)="getInfoAround()" [matTooltip]="'MAP.AROUND' | translate">
          <mat-icon>share_location</mat-icon>
        </button>

        <button
          matMiniFab
          color="accent"
          (click)="switchDirectionActive()"
          [matTooltip]="'MAP.ITINERARY' | translate">
          <mat-icon>edit_road</mat-icon>
        </button>

        <ng-container *hasPermission="['WRITE', 'mission']">
          <button
            matMiniFab
            color="accent"
            (click)="generateMission()"
            [matTooltip]="'TAB.MISSION' | translate">
            <mat-icon>send</mat-icon>
          </button>
        </ng-container>
      </div>

      <mat-icon class="click-address-close" (click)="closeMapAction()">close</mat-icon>
    }
  </div>
}
